// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationC_pagination__B9my3"};